import { render, staticRenderFns } from "./zombieSource.vue?vue&type=template&id=b88bcc54&scoped=true&"
import script from "./zombieSource.vue?vue&type=script&lang=js&"
export * from "./zombieSource.vue?vue&type=script&lang=js&"
import style0 from "./zombieSource.vue?vue&type=style&index=0&id=b88bcc54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88bcc54",
  null
  
)

export default component.exports